module.exports = __webpack_public_path__ + "img/mix_ucl_spacetimelab.7cbc8f53.jpg";